var _defs, _path, _path2, _path3, _path4, _path5, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgValluMusta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 161.09 62.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m29.68,27.59l11.32,18.3-2.5,1.7L53.51,7.09h6.5l-18,44.5h-5l-14-24h6.68Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m68.6,51.78c-2.2,0-4.22-.47-6.04-1.43-1.79-.95-3.21-2.34-4.28-4.16-1.03-1.86-1.54-4.12-1.54-6.78s.55-4.88,1.65-6.78c1.1-1.94,2.57-3.42,4.39-4.45,1.86-1.03,3.9-1.54,6.1-1.54s4.07.51,5.59,1.54c1.52.99,2.68,2.17,3.48,3.53l-.34.91.51-5.02h4.9v23.6h-5.3v-6.16l.57,1.37c-.15.38-.49.87-1.03,1.48-.49.57-1.18,1.16-2.05,1.77-.84.61-1.81,1.12-2.91,1.54-1.1.38-2.34.57-3.7.57Zm1.42-4.39c1.33,0,2.53-.25,3.59-.74,1.06-.49,1.94-1.18,2.62-2.05.72-.91,1.22-2,1.48-3.25v-4.62c-.3-1.14-.84-2.13-1.6-2.96-.76-.87-1.67-1.54-2.74-2-1.06-.49-2.24-.74-3.53-.74-1.41,0-2.7.34-3.88,1.03-1.18.68-2.13,1.63-2.85,2.85-.68,1.22-1.03,2.64-1.03,4.28,0,1.52.36,2.91,1.08,4.16.72,1.25,1.69,2.24,2.91,2.96,1.22.72,2.53,1.08,3.93,1.08Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m92.19,7.09h5.3v44.12h-5.3V7.09Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m106.66,7.09h5.3v44.12h-5.3V7.09Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m128.6,52.12c-2.13,0-3.89-.65-5.3-1.94-1.37-1.33-2.09-3.04-2.17-5.13v-17.44h5.3v15.56c.08,1.29.44,2.34,1.08,3.14.68.8,1.75,1.22,3.19,1.25,1.33,0,2.51-.38,3.53-1.14,1.06-.8,1.92-1.86,2.57-3.19.65-1.37.97-2.91.97-4.62v-11h5.3v23.6h-4.85l-.46-5.81.28,1.03c-.46,1.1-1.16,2.09-2.11,2.96-.91.84-1.99,1.5-3.25,2-1.25.49-2.62.74-4.1.74Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 53.01,
    y: 29.1,
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m55.01,53.17h-2v-1.92h2v1.92Zm0-3.84h-2v-1.92h2v1.92Zm0-3.84h-2v-1.92h2v1.92Zm0-3.85h-2v-1.92h2v1.92Zm0-3.84h-2v-1.92h2v1.92Zm0-3.84h-2v-1.92h2v1.92Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 53.01,
    y: 55.09,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m51.07,57.09h-1.94v-2h1.94v2Zm-3.88,0h-1.94v-2h1.94v2Zm-3.88,0h-1.94v-2h1.94v2Zm-3.88,0h-1.94v-2h1.94v2Zm-3.88,0h-1.94v-2h1.94v2Zm-3.88,0h-1.94v-2h1.94v2Zm-3.88,0h-1.94v-2h1.94v2Zm-3.88,0h-1.94v-2h1.94v2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 18.01,
    y: 55.09,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m20.01,53.15h-2v-1.94h2v1.94Zm0-3.88h-2v-1.94h2v1.94Zm0-3.88h-2v-1.94h2v1.94Zm0-3.88h-2v-1.94h2v1.94Zm0-3.88h-2v-1.94h2v1.94Zm0-3.88h-2v-1.94h2v1.94Zm0-3.88h-2v-1.94h2v1.94Zm0-3.88h-2v-1.94h2v1.94Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 18.01,
    y: 20.09,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m40.76,22.09h-2.08v-2h2.08v2Zm-4.15,0h-2.08v-2h2.08v2Zm-4.15,0h-2.08v-2h2.08v2Zm-4.15,0h-2.08v-2h2.08v2Zm-4.15,0h-2.08v-2h2.08v2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 42.83,
    y: 20.09,
    width: 1,
    height: 2
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValluMusta);
export default __webpack_public_path__ + "static/media/_Vallu_musta.ba58a85493651497b5d6ef00d0153828.svg";
export { ForwardRef as ReactComponent };